<template>
  <div class="v2-footer">
    <div class="container">
      <div class="row">
        <div class="d-md-none d-lg-flex col-lg-3 logo-col mb-4 mb-md-0">
          <component :is="useRoute().path == '/' ? 'div' : 'router-link'" to="/" class="navbar-brand">
            <img :src="logo" width="103" height="43" :alt="`Ersties Logo`" />
          </component>
          <social-buttons class="d-md-none" />
          <button v-modal.modal-apply-model class="btn btn-sm btn-light-pink d-none d-md-inline-block">
            {{ t("Apply to be a model") }}
          </button>
        </div>
        <div class="col-md-6 col-lg-5 menu-col">
          <div class="row">
            <div class="col-md-6 mb-2 mb-md-0">
              <div class="menu-main-item" data-bs-toggle="collapse" aria-expanded="false" role="button" href="#navigation-menu">
                <span>{{ t("Menu") }}</span>
                <span class="caret d-md-none">
                  <i class="icon icon-angle-down" />
                </span>
              </div>
              <ul id="navigation-menu" class="menu collapse">
                <li v-for="(item, i) in menuItems" :key="i" class="menu-item">
                  <router-link :to="item.url">
                    {{ item.anchor }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <div class="menu-main-item" data-bs-toggle="collapse" aria-expanded="false" role="button" href="#info-menu">
                <span>{{ t("Info") }}</span>
                <span class="caret d-md-none">
                  <i class="icon icon-angle-down" />
                </span>
              </div>
              <ul id="info-menu" class="menu collapse">
                <li v-for="(item, i) in infoItems" :key="i" class="menu-item">
                  <a :href="item.url">{{ item.anchor }}</a>
                </li>
              </ul>
            </div>
          </div>
          <button
            v-modal.modal-apply-model
            class="btn btn-sm btn-light-pink d-inline-block d-lg-none mb-4 mb-md-0 mt-4 mt-md-3 wide"
            @click="sendButtonTrack"
          >
            {{ t("Apply to be a model") }}
          </button>
        </div>
        <div class="col-md-6 col-lg-4 subscribe-col">
          <div class="subscribe rounded-1">
            <h4>{{ t("Get more fun in your inbox") }}</h4>
            <form-subscribe />
            <social-buttons icons-only class="d-none d-md-block mt-3" />
          </div>
        </div>
      </div>
    </div>

    <modal-apply-model />
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";
import SocialButtons from "@/components/v2/social-buttons/index.vue";
import FormSubscribe from "@/components/v2/form-subscribe/index.vue";
import { getAffiliateUrl, getTld } from "@/utils/urlHelper";
import { amplitudeButtonClickTrack } from "@/utils/amplitude";
import { MenuItem } from "@/interfaces/MenuItem.ts";
import { useRoute } from "vue-router";
import logoDe from "@/assets/v2/images/logo-de.svg";
import logoEn from "@/assets/v2/images/logo-en.svg";

const ModalApplyModel = defineAsyncComponent(() => import("@/components/v2/modals/modal-apply-model"));

defineProps({
  menuItems: {
    type: Array as PropType<MenuItem[]>,
    required: true,
  },
});

const { locale, t } = useI18n();

const infoItems = computed<MenuItem[]>(() => {
  const items: MenuItem[] = [
    { url: "/contact-us", anchor: t("Contact us") },
    { url: "/agb#privacy_policy", anchor: t("Privacy Policy") },
    { url: "/agb#legal", anchor: t("Terms & Conditions") },
    { url: "/agb", anchor: t("Imprint") },
  ];

  if (getTld() !== "net") {
    items.push({ url: getAffiliateUrl(), anchor: t("Affiliates"), external: true });
  }

  items.push({ url: "/report", anchor: t("Content Removal Request / DMCA") });
  items.push({ url: "/prohibited_content", anchor: t("Prohibited Content") });
  return items;
});

const logo = computed(() => (locale.value === "de" ? logoDe : logoEn));

const sendButtonTrack = () => {
  amplitudeButtonClickTrack("apply to be a model");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
